import {inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {
    CloudMigrNatisFormRequest,
    CloudMigrNatisFormResponse,
    NatisDocsRequest,
    NatisDocsResponse,
    NatisReleaseRequest,
    NatisReleaseResponse,
} from '../models/natis-docs.model';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root',
})
export class NatisDocsService {

    private readonly http = inject(HttpClient);
    private readonly authService = inject(AuthService);

    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        let headers = new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);

        return headers;
    }

    getNatisDocs(
        requestPayload: NatisDocsRequest
    ): Observable<NatisDocsResponse> {
        const url = '/natis-docs';
        return this.http.post<NatisDocsResponse>(url, requestPayload, { headers: this.getHeaders() });
    }

    releaseVehicle(
        requestPayload: NatisReleaseRequest
    ): Observable<NatisReleaseResponse> {
        const url = '/natis-release';
        return this.http.post<NatisReleaseResponse>(url, requestPayload, { headers: this.getHeaders() });
    }

    getNatisDocInfo(
        requestPayload: CloudMigrNatisFormRequest
    ): Observable<CloudMigrNatisFormResponse> {
        const url = '/natis-doc-info';
        return this.http.post<CloudMigrNatisFormResponse>(url, requestPayload, { headers: this.getHeaders() });
    }
}
